import { MenuItem, Stack, Typography } from "@mui/material";
import { BubbleChartItem } from "./BubbleChartBtn";

export const BubbleLegendBlock = ({
  handleLegendClick,
  selectedRole,
  roles,
}: {
  selectedRole: string;
  handleLegendClick: (role: string) => void;
  roles: BubbleChartItem[];
}) => {
  return (
    <Stack
      minWidth="300px"
      maxWidth="300px"
      gap="8px"
      padding="20px 16px"
      flexShrink={0}
    >
      <Stack flexDirection="row" justifyContent="space-between">
        <Typography sx={{ color: "#1F293299" }}>Role</Typography>
        <Typography sx={{ color: "#1F293299", textAlign: "left" }}>
          Deviation
        </Typography>
      </Stack>
      <Stack>
        {roles.map(({ role, color, label, expected, actual }) => (
          <MenuItem
            onMouseEnter={() => handleLegendClick(role)}
            onMouseLeave={() => handleLegendClick(role)}
            key={role}
            sx={{ padding: "8px" }}
            selected={selectedRole === role}
          >
            <Stack
              flexDirection="row"
              justifyContent="space-between"
              flexGrow={1}
            >
              <Stack flexDirection="row" alignItems="center" gap="12px">
                <span
                  style={{
                    backgroundColor: color,
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                  }}
                />
                <Typography sx={{ color: "#121212" }}>{label}</Typography>
              </Stack>

              <Stack
                flexDirection="row"
                justifyContent="flex-end"
                color="#121212"
              >
                {actual - expected > 0
                  ? `+${actual - expected}`
                  : actual - expected}
              </Stack>
            </Stack>
          </MenuItem>
        ))}
      </Stack>
    </Stack>
  );
};
